import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const ribbonVariants = cva(
  'absolute z-10 px-3 py-1 text-xs font-semibold text-white shadow-theme-sm',
  {
    variants: {
      variant: {
        primary: 'bg-brand-500',
        success: 'bg-success-500',
        error: 'bg-error-500',
        warning: 'bg-warning-500',
        dark: 'bg-gray-900',
      },
      position: {
        'top-left': 'left-0 top-0 rounded-br-lg',
        'top-right': 'right-0 top-0 rounded-bl-lg',
        'bottom-left': 'bottom-0 left-0 rounded-tr-lg',
        'bottom-right': 'bottom-0 right-0 rounded-tl-lg',
      },
    },
    defaultVariants: {
      variant: 'primary',
      position: 'top-right',
    },
  }
);

export interface RibbonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof ribbonVariants> {}

export const Ribbon = React.forwardRef<HTMLDivElement, RibbonProps>(
  ({ className, variant, position, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(ribbonVariants({ variant, position }), className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Ribbon.displayName = 'Ribbon';
